import { t } from '@lingui/core/macro';
import { useDocumentMetadata } from '../../components/DocumentMetadataProvider';
import { getMetadataDisplayValue } from '../../components/getMetadataDisplayValue';
export function useGeSyncMetadataMock() {
    var _a, _b, _c, _d, _e;
    const { data, documentId, activeEntries } = useDocumentMetadata();
    const { systemData, properties } = data;
    const details = [
        {
            id: 'system:document-id',
            label: t({
                message: 'Document id',
                comment: 'Label for document id',
            }),
            value: documentId,
        },
        {
            id: 'system:document-name',
            label: t({
                message: 'Document name',
                comment: 'Label for document name',
            }),
            value: (_a = systemData.name) !== null && _a !== void 0 ? _a : '',
        },
        {
            id: 'system:document-status',
            label: t({
                message: 'Document Status',
                comment: 'Metadata sidebar: Label for document status',
            }),
            value: (_b = systemData.status) !== null && _b !== void 0 ? _b : '',
        },
        {
            id: 'system:created-at',
            label: t({
                message: 'Created at',
                comment: 'Label for document creation date',
            }),
            value: (_c = systemData.createdAt) !== null && _c !== void 0 ? _c : '',
        },
        {
            id: 'system:updated-at',
            label: t({
                message: 'Updated at',
                comment: 'Label for document last update date',
            }),
            value: (_d = systemData.updatedAt) !== null && _d !== void 0 ? _d : '',
        },
        {
            id: 'system:created-by',
            label: t({
                message: 'Created by',
                comment: 'Label for document creator',
            }),
            value: systemData.createdBy,
        },
        {
            id: 'system:template-category',
            label: t({
                message: 'Template category',
                comment: 'Metadata: Label for template category',
            }),
            value: (_e = systemData.category) !== null && _e !== void 0 ? _e : '',
        },
    ];
    const custom = properties
        .filter(({ property }) => property.companyId)
        .map(({ property, pair }) => ({
        id: property.id,
        label: property.label,
        value: getMetadataDisplayValue({
            value: pair.value,
            property,
        }),
    }));
    const standard = properties
        .filter(({ property }) => activeEntries.includes(property.name) && !property.companyId)
        .map(({ property, pair }) => ({
        id: property.id,
        label: property.label,
        value: getMetadataDisplayValue({
            value: pair.value,
            property,
        }),
    }));
    return {
        details,
        custom,
        standard,
    };
}
